import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import Swal from "sweetalert2";

import UserSidebar from "../components/user/UserSidebar";
import UserHeader from "../components/user/UserHeader";

import {
    userMe,
    getSubscriptions
} from "../config/userApi";

import getDomainDetails from "../config/domainDetails";


function Subscription() {

    const navigate = useNavigate();


    const [sidebarOpen, setSidebarOpen] =
        useState(false);


    const [name, setName] =
        useState("Student");


    const [user, setUser] =
        useState(null);


    const [plans, setPlans] =
        useState([]);


    const [loading, setLoading] =
        useState(true);


    const [error, setError] =
        useState("");


    const [whatsappNumber, setWhatsappNumber] =
        useState("");


    /*
    |--------------------------------------------------------------------------
    | Load User + Subscription Plans + WhatsApp
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        const loadSubscriptions = async () => {

            try {

                setLoading(true);

                setError("");


                /*
                |--------------------------------------------------------------------------
                | Check Logged In User
                |--------------------------------------------------------------------------
                */

                const meResponse =
                    await userMe();


                console.log(
                    "USER ME STATUS:",
                    meResponse.status
                );


                /*
                |--------------------------------------------------------------------------
                | Unauthorized
                |--------------------------------------------------------------------------
                */

                if (meResponse.status === 401) {

                    Cookies.remove("username");
                    Cookies.remove("user_id");
                    Cookies.remove("user_user_id");
                    Cookies.remove("user_email");

                    navigate("/login", {
                        replace: true
                    });

                    return;

                }


                /*
                |--------------------------------------------------------------------------
                | Read User Response
                |--------------------------------------------------------------------------
                */

                const meResult =
                    await meResponse.json();


                console.log(
                    "USER ME RESPONSE:",
                    meResult
                );


                if (!meResponse.ok) {

                    throw new Error(
                        meResult.message ||
                        "Unable to verify user login."
                    );

                }


                /*
                |--------------------------------------------------------------------------
                | Set User Information
                |--------------------------------------------------------------------------
                */

                if (meResult.user) {

                    const currentUser =
                        meResult.user;


                    setUser(
                        currentUser
                    );


                    /*
                    |--------------------------------------------------------------------------
                    | Full Name
                    |--------------------------------------------------------------------------
                    */

                    const username =
                        currentUser.fullname ||
                        currentUser.name ||
                        currentUser.username ||
                        "Student";


                    setName(
                        username
                    );


                    /*
                    |--------------------------------------------------------------------------
                    | Save User ID
                    |--------------------------------------------------------------------------
                    */

                    if (
                        currentUser.user_id !== undefined &&
                        currentUser.user_id !== null
                    ) {

                        Cookies.set(
                            "user_user_id",
                            String(currentUser.user_id),
                            {
                                expires: 7,
                                sameSite: "Lax"
                            }
                        );

                    }


                    /*
                    |--------------------------------------------------------------------------
                    | Full Name
                    |--------------------------------------------------------------------------
                    */

                    if (currentUser.fullname) {

                        Cookies.set(
                            "username",
                            currentUser.fullname,
                            {
                                expires: 7,
                                sameSite: "Lax"
                            }
                        );

                    }


                    /*
                    |--------------------------------------------------------------------------
                    | Email
                    |--------------------------------------------------------------------------
                    */

                    if (currentUser.email) {

                        Cookies.set(
                            "user_email",
                            currentUser.email,
                            {
                                expires: 7,
                                sameSite: "Lax"
                            }
                        );

                    }

                }


                /*
                |--------------------------------------------------------------------------
                | Get Subscription Plans
                |--------------------------------------------------------------------------
                */

                const response =
                    await getSubscriptions();


                console.log(
                    "SUBSCRIPTION STATUS:",
                    response.status
                );


                /*
                |--------------------------------------------------------------------------
                | Unauthorized
                |--------------------------------------------------------------------------
                */

                if (response.status === 401) {

                    Cookies.remove("username");
                    Cookies.remove("token");
                    Cookies.remove("user_user_id");
                    Cookies.remove("user_email");

                    navigate("/login", {
                        replace: true
                    });

                    return;

                }


                /*
                |--------------------------------------------------------------------------
                | Read Response
                |--------------------------------------------------------------------------
                */

                const result =
                    await response.json();


                console.log(
                    "SUBSCRIPTION RESPONSE:",
                    result
                );


                /*
                |--------------------------------------------------------------------------
                | API Error
                |--------------------------------------------------------------------------
                */

                if (!response.ok) {

                    throw new Error(
                        result.message ||
                        "Unable to fetch subscription plans."
                    );

                }


                /*
                |--------------------------------------------------------------------------
                | Set Plans
                |--------------------------------------------------------------------------
                */

                setPlans(
                    Array.isArray(result.data)
                        ? result.data
                        : []
                );


                /*
                |--------------------------------------------------------------------------
                | Get WhatsApp Number
                |--------------------------------------------------------------------------
                */

                try {

                    const domainResponse =
                        await getDomainDetails();


                    console.log(
                        "DOMAIN DETAILS:",
                        domainResponse
                    );


                    if (
                        domainResponse?.success &&
                        domainResponse?.data?.whatsapp
                    ) {

                        const number =
                            String(
                                domainResponse.data.whatsapp
                            ).replace(
                                /\D/g,
                                ""
                            );


                        setWhatsappNumber(
                            number
                        );

                    }

                } catch (whatsappError) {

                    console.error(
                        "WHATSAPP NUMBER ERROR:",
                        whatsappError
                    );

                }

            }
            catch (err) {

                console.error(
                    "SUBSCRIPTION ERROR:",
                    err
                );


                setError(
                    err.message ||
                    "Unable to connect with server."
                );

            }
            finally {

                setLoading(false);

            }

        };


        loadSubscriptions();

    }, [navigate]);


    /*
    |--------------------------------------------------------------------------
    | Purchase / WhatsApp Function
    |--------------------------------------------------------------------------
    */

    const handlePurchase = (plan) => {

        if (!user) {

            navigate("/login", {
                replace: true
            });

            return;

        }


        if (!whatsappNumber) {

            Swal.fire({
                icon: "warning",
                title: "WhatsApp Unavailable",
                text: "WhatsApp number is not available."
            });

            return;

        }


        /*
        |--------------------------------------------------------------------------
        | User Information
        |--------------------------------------------------------------------------
        */

        const userId =
            user.user_id || "";


        const fullname =
            user.fullname ||
            user.name ||
            user.username ||
            "";


        const email =
            user.email || "";


        /*
        |--------------------------------------------------------------------------
        | Plan Information
        |--------------------------------------------------------------------------
        */

        const paper =
            plan.paper || "";


        const price =
            plan.price || "";


        /*
        |--------------------------------------------------------------------------
        | WhatsApp Message
        |--------------------------------------------------------------------------
        */

        const message = `
Hello HomoeoAdda,

I want to purchase this plan.

Title: ${paper}
Price: ₹${price}

User ID: ${userId}
Name: ${fullname}
Email: ${email}

Thank you.
HomoeoAdda
        `.trim();


        /*
        |--------------------------------------------------------------------------
        | WhatsApp URL
        |--------------------------------------------------------------------------
        */

        const whatsappUrl =
            `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
                message
            )}`;


        console.log(
            "WHATSAPP PURCHASE URL:",
            whatsappUrl
        );


        /*
        |--------------------------------------------------------------------------
        | Open WhatsApp
        |--------------------------------------------------------------------------
        */

        window.open(
            whatsappUrl,
            "_blank",
            "noopener,noreferrer"
        );

    };


    /*
    |--------------------------------------------------------------------------
    | Loading
    |--------------------------------------------------------------------------
    */

    if (loading) {

        return (

            <div className="user-dashboard">

                <UserSidebar
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                />


                <main className="dashboard-main">

                    <UserHeader
                        name={name}
                        setSidebarOpen={setSidebarOpen}
                    />


                    <div
                        className="d-flex flex-column align-items-center justify-content-center"
                        style={{
                            minHeight: "60vh"
                        }}
                    >

                        <div
                            className="spinner-border text-primary mb-3"
                            role="status"
                        >

                            <span className="visually-hidden">
                                Loading...
                            </span>

                        </div>


                        <h6 className="text-muted">
                            Loading Subscription Plans...
                        </h6>

                    </div>

                </main>

            </div>

        );

    }


    /*
    |--------------------------------------------------------------------------
    | Main UI
    |--------------------------------------------------------------------------
    */

    return (

        <div className="user-dashboard">


            {/* =====================================================
                SIDEBAR
            ===================================================== */}

            <UserSidebar
                sidebarOpen={sidebarOpen}
                setSidebarOpen={setSidebarOpen}
            />


            {/* =====================================================
                MAIN
            ===================================================== */}

            <main className="dashboard-main">


                {/* =================================================
                    HEADER
                ================================================= */}

                <UserHeader
                    name={name}
                    setSidebarOpen={setSidebarOpen}
                />


                {/* =================================================
                    CONTENT
                ================================================= */}

                <div className="dashboard-content">


                    {/* =================================================
                        PAGE HEADER
                    ================================================= */}

                    <div
                        className="rounded-4 p-4 p-md-5 mb-4 text-white"
                        style={{
                            background:
                                "linear-gradient(135deg, #0d6efd, #084298)"
                        }}
                    >

                        <div className="row align-items-center">

                            <div className="col-lg-9">

                                <span
                                    className="badge bg-white text-primary px-3 py-2 mb-3"
                                >

                                    <i className="bi bi-stars me-2"></i>

                                    PREMIUM SUBSCRIPTION

                                </span>


                                <h1
                                    className="fw-bold mb-2"
                                >

                                    Choose Your Subscription

                                </h1>


                                <p
                                    className="mb-0 opacity-75"
                                >

                                    Upgrade your preparation with
                                    premium MCQ papers and practice
                                    resources.

                                </p>

                            </div>


                            <div className="col-lg-3 text-lg-end mt-4 mt-lg-0">

                                <i
                                    className="bi bi-award"
                                    style={{
                                        fontSize: "80px",
                                        opacity: 0.25
                                    }}
                                ></i>

                            </div>

                        </div>

                    </div>


                    {/* =================================================
                        ERROR
                    ================================================= */}

                    {error && (

                        <div
                            className="alert alert-danger rounded-3"
                        >

                            <i
                                className="bi bi-exclamation-triangle-fill me-2"
                            ></i>

                            {error}

                        </div>

                    )}


                    {/* =================================================
                        NO PLANS
                    ================================================= */}

                    {!error && plans.length === 0 && (

                        <div
                            className="text-center bg-white rounded-4 shadow-sm p-5"
                        >

                            <div
                                className="d-flex align-items-center justify-content-center mx-auto mb-3 rounded-circle bg-light text-primary"
                                style={{
                                    width: "80px",
                                    height: "80px"
                                }}
                            >

                                <i
                                    className="bi bi-box-seam"
                                    style={{
                                        fontSize: "35px"
                                    }}
                                ></i>

                            </div>


                            <h4 className="fw-bold">

                                No Subscription Plans Available

                            </h4>


                            <p className="text-muted mb-0">

                                There are currently no subscription
                                plans available.

                            </p>

                        </div>

                    )}


                    {/* =================================================
                        PLANS
                    ================================================= */}

                    {plans.length > 0 && (

                        <div className="row g-4">


                            {plans.map((plan, index) => (

                                <div
                                    className="col-xl-4 col-md-6"
                                    key={plan.id}
                                >

                                    <div
                                        className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden"
                                    >


                                        {/* PLAN HEADER */}

                                        <div
                                            className="text-center text-white p-4"
                                            style={{
                                                background:
                                                    "linear-gradient(135deg, #0d6efd, #084298)"
                                            }}
                                        >

                                            <div
                                                className="mb-2"
                                            >

                                                <span
                                                    className="badge bg-white text-primary rounded-pill px-3 py-2"
                                                >

                                                    PLAN {index + 1}

                                                </span>

                                            </div>


                                            <h3
                                                className="fw-bold mb-0"
                                            >

                                                {plan.paper}

                                            </h3>

                                        </div>


                                        {/* PLAN BODY */}

                                        <div
                                            className="card-body p-4"
                                        >


                                            {/* PRICE */}

                                            <div
                                                className="text-center mb-4"
                                            >

                                                <div
                                                    className="d-flex align-items-center justify-content-center"
                                                >

                                                    <span
                                                        className="text-muted fs-5 me-1"
                                                    >
                                                        ₹
                                                    </span>

                                                    <span
                                                        className="display-5 fw-bold text-dark"
                                                    >
                                                        {plan.price}
                                                    </span>

                                                </div>


                                                <div
                                                    className="text-muted mt-1"
                                                >

                                                    <i
                                                        className="bi bi-clock me-1"
                                                    ></i>

                                                    {plan.duration}

                                                </div>

                                            </div>


                                            {/* FEATURES */}

                                            <div className="mb-4">


                                                {plan.detail1 && (

                                                    <div
                                                        className="d-flex align-items-start border-bottom py-3"
                                                    >

                                                        <i
                                                            className="bi bi-check-circle-fill text-success me-2 mt-1"
                                                        ></i>

                                                        <span>
                                                            {plan.detail1}
                                                        </span>

                                                    </div>

                                                )}


                                                {plan.detail2 && (

                                                    <div
                                                        className="d-flex align-items-start border-bottom py-3"
                                                    >

                                                        <i
                                                            className="bi bi-check-circle-fill text-success me-2 mt-1"
                                                        ></i>

                                                        <span>
                                                            {plan.detail2}
                                                        </span>

                                                    </div>

                                                )}


                                                {plan.detail3 && (

                                                    <div
                                                        className="d-flex align-items-start border-bottom py-3"
                                                    >

                                                        <i
                                                            className="bi bi-check-circle-fill text-success me-2 mt-1"
                                                        ></i>

                                                        <span>
                                                            {plan.detail3}
                                                        </span>

                                                    </div>

                                                )}


                                                {plan.detail4 && (

                                                    <div
                                                        className="d-flex align-items-start py-3"
                                                    >

                                                        <i
                                                            className="bi bi-check-circle-fill text-success me-2 mt-1"
                                                        ></i>

                                                        <span>
                                                            {plan.detail4}
                                                        </span>

                                                    </div>

                                                )}

                                            </div>


                                            {/* PURCHASE BUTTON */}

                                            {plan.link ? (

                                                <button
                                                    type="button"
                                                    onClick={() =>
                                                        handlePurchase(plan)
                                                    }
                                                    className="btn btn-success w-100 rounded-3 py-2 fw-semibold"
                                                >

                                                    <i
                                                        className="bi bi-whatsapp me-2"
                                                    ></i>

                                                    Purchase Now

                                                    <i
                                                        className="bi bi-arrow-right ms-2"
                                                    ></i>

                                                </button>

                                            ) : (

                                                <button
                                                    type="button"
                                                    className="btn btn-secondary w-100 rounded-3 py-2"
                                                    disabled
                                                >

                                                    Purchase Unavailable

                                                </button>

                                            )}

                                        </div>

                                    </div>

                                </div>

                            ))}


                        </div>

                    )}

                </div>

            </main>

        </div>

    );

}


export default Subscription;